import React, { type FC, useCallback } from "react";

import { useCoreChart } from "~/feature/chart/providers/CoreChartProvider";
import { EventChartRangeEnum } from "~/feature/chart/types";

import * as Styled from "./ChartRange.styles";

export const ChartRange: FC = () => {
  const { range, setRange } = useCoreChart();

  const handleOnChange = useCallback(
    (_: React.MouseEvent<HTMLElement>, range: EventChartRangeEnum | null) => {
      if (range) {
        setRange(range);
      }
    },
    [setRange]
  );

  return (
    <Styled.Group exclusive value={range} onChange={handleOnChange}>
      {Object.values(EventChartRangeEnum).map((rangeOption) => (
        <Styled.Button key={rangeOption} value={rangeOption}>
          {rangeOption}
        </Styled.Button>
      ))}
    </Styled.Group>
  );
};
